import {
	collection,
	addDoc,
	getDocs,
	query,
	doc,
	deleteDoc,
	setDoc,
} from '@firebase/firestore';
import { Timestamp } from 'firebase/firestore';
import {
	handleError,
	handleSuccess,
	handleWarning,
	superadminContact,
	whichEnvURL,
} from '../helpers/utils';
import { types } from '../types/types';
import {
	getStorage,
	uploadBytes,
	ref as newRef,
	getDownloadURL,
} from 'firebase/storage';
import { app, db } from '../firebase/firebase-config';
import { bucketRef } from '../firebase/credentials';
import { template1 } from '../helpers/whatsappApi';

export const setCurrentFolder = (data) => ({
	type: types.setFolders,
	payload: data,
});

export const resetPath = () => ({
	type: types.resetPath,
});

export const setCurrentPath = (path) => ({
	type: types.currentPath,
	payload: path,
});

const formatFolderName = (name) => {
	for (let i = 0; i < name.length - 1; i++)
		name = name.replace(' ', '_').trim();
	return name;
};

const folderTemplate = (path, name, isPrivate = false) => ({
	path,
	isFile: false,
	isPrivate,
	name: formatFolderName(name),
	created: Timestamp.fromDate(new Date()),
});

// Create workspace in firebase
export const createWorkspace = (order, user) => {
	setDoc(doc(db, 'orders', order?.number_order), {
		number_order: order?.number_order,
		created_by: {
			email: user?.email,
			first_name: user?.first_name,
			last_name: user?.last_name,
			id: user?.id,
			division: user?.division,
			phone_number: user?.phone_number,
			user_type: user?.user_type,
			area: user?.area,
		},
		created: Timestamp.fromDate(new Date()),
	})
		.then(() => {
			const rootPath = `${
				whichEnvURL(true) === 'live' ? 'orders' : 'orders_stage'
			}/${order?.number_order}/folders`;
			const defaultFolders = [
				folderTemplate(rootPath, 'FICHAS_TÉCNICAS_LOGO'),
				folderTemplate(rootPath, 'FICHAS_TÉCNICAS_PRENDAS'),
				folderTemplate(rootPath, 'CONFIRMACIÓN_DE_EXISTENCIA'),
				folderTemplate(rootPath, 'ALTA_CLIENTE', true),
				folderTemplate(rootPath, 'EMPAQUE', true),
				folderTemplate(rootPath, 'ORDEN_DE_COMPRA', true),
				folderTemplate(rootPath, 'PREFACTURA', true),
				folderTemplate(rootPath, 'ANTICIPO', true),
			];
			const dbRef = collection(db, rootPath);
			defaultFolders.forEach(async (folder) => {
				await addDoc(dbRef, folder);
			});
		})
		.catch((error) => {
			sendWhatsApp(
				order,
				user,
				[{ name: 'Fernando López Ramírez', superadminContact }],
				template1(
					'ORIGIN',
					'ROOT',
					order?.number_order,
					`Workspace error: ${error.message}`
				)
			);
		});
};

// Get folder content (documents and collections)
export const getFolder = (path) => {
	return (dispatch) => {
		let files = [];
		console.log('GET FOLDER: ', path);
		// Get folder
		getDocs(query(collection(db, path)))
			.then((snapshot) => {
				snapshot.forEach(async (doc) => {
					files.push({
						uid: doc.id,
						...doc.data(),
					});
				});
				dispatch(setCurrentFolder(files));
				dispatch(setCurrentPath(path));
			})
			.catch((error) => {
				handleError(error, 'Error getting folders');
			});
	};
};

// Create folder
export const createFolder = (name, path) => {
	return (dispatch) => {
		// const newPath = `${path}/folders`;
		const dbRef = collection(db, path);

		const newFolder = folderTemplate(path, name);

		addDoc(dbRef, newFolder)
			.then(({ id }) => {
				// Update folders in Redux from DB
				dispatch(getFolder(path));
			})
			.catch((error) => {
				handleError(error, 'Error creating folder');
			});
	};
};

export const getSubFolder = async (path) => {
	const subfolders = [];
	const querySnapshot = await getDocs(query(collection(db, path)));
	if (querySnapshot.docs.length > 0) {
		querySnapshot.forEach((doc) => {
			subfolders.push({ uid: doc.id, ...doc.data() });
		});
	}
	return subfolders;
};

// export const prepareRecursiveDeletion = (path) => {
//     return (dispatch) => {
//         getSubFolder(path)
//             .then((docs) => {
//                 if (docs.length > 0) {
//                     dispatch(deleteFolder(docs, 0));
//                     console.log(docs);
//                 } else {
//                     console.log('Vacío');
//                 }
//             })
//             .catch((error) => {
//                 console.log('Error preparation: ', error);
//             })
//     }
// }

export const getParentFolder = (path, times = 1) => {
	let res = path;
	for (let i = 0; i < times; i++) {
		path = res.split('/folders');
		path.pop();
		res = path.join('/folders');
	}
	return res;
};

export const deleteSingleDocument = async (path) => {
	try {
		await deleteDoc(doc(db, path));
		handleSuccess('Eliminado');
	} catch (error) {
		handleError(error, 'Ocurrió un error al tratar de eliminar');
	}
};

// export const uploadFileIntoFolder = async (path, objFile) => {
//     return (dispatch) => {
//         updateDoc(doc(db, path), {
//             files: arrayUnion(objFile)
//         })
//             .then(() => console.log('Uploaded into folder'))
//             .catch((error) => console.log('Error uploadeing into folder: ', error));
//     }
// }

// Delete folders recursively
export const deleteFolder = async (obj, count, originPath) => {
	// Caso base
	if (count === obj.length) {
		const path = getParentFolder(originPath);
		// console.log('ORIGIN: ', path);
		await deleteDoc(doc(db, path));
		return;
	}

	// Get element from DB (by order not by id)
	const item = obj[count];
	const itemPath = `${item.path}/${item.uid}`;
	const folders = await getSubFolder(`${itemPath}/folders`);

	// Check for any subfolder
	if (folders.length > 0) deleteFolder(folders, 0, originPath);

	// Delete doc
	await deleteDoc(doc(db, itemPath));

	// Move on
	return deleteFolder(obj, (count += 1), originPath);
};

export const getStorageType = (type) => {
	switch (type) {
		case 'img':
			return 'users';
		case 'file':
			return 'users';
		case 'repo':
			return 'users';
		case 'fileConsult':
			return 'orders';
		default:
			return 'otros';
	}
};

// Upload to storage and return URL reference
export const getURLFileUploadStorage = async (file, filename) => {
	// Get a reference to the Firebase Storage root
	const storageRef = getStorage(app, bucketRef);
	const path = `/users_profile_pictures/${filename}`;
	const fileRef = newRef(storageRef, path);

	await uploadBytes(fileRef, file);
	return await getDownloadURL(fileRef);
};

// Update
export const updateOrderFileURL = (url, description) => {
	return (_, getState) => {
		const { uid } = getState().auth;
		const dbRef = collection(db, `users/${uid}/documents`);

		addDoc(dbRef, { url: url, description: description })
			.then(() => {
				handleSuccess('Archivo guardado en la orden');
			})
			.catch((error) => {
				handleError(error, 'Error actualizando archivo en el perfil');
			});
	};
};

// Add a new document with the data of the file
export const updateConsultFileURL = (url, filename) => {
	return (dispatch, getState) => {
		const { currentPath } = getState().files;
		const dbRef = collection(db, currentPath);
		const newFile = {
			// files: [],
			// To know the exact path just add "/{uid}".
			path: currentPath,
			url: url,
			isFile: true,
			isPrivate: false,
			name: filename,
			created: Timestamp.fromDate(new Date()),
		};

		addDoc(dbRef, newFile)
			.then(() => {
				handleSuccess('Archivo guardado');
				// Bring updated consults
				// dispatch(getConsults());
				const currentFolder =
					getParentFolder(currentPath, 2) + '/folders';
				console.log('Current path after upload: ', currentFolder);
				setTimeout(() => {
					dispatch(getFolder(currentPath));
				}, 1000);
			})
			.catch((error) => {
				handleError(error, 'Error al guardar archivo en la orden.');
			});
	};
};

export const uploadFile = (
	file,
	type,
	newFilename = null,
	consultUid = null
) => {
	return (dispatch, getState) => {
		const typeRef = getStorageType(type);
		const filename = newFilename?.includes('.') ? newFilename : file.name;
		const { uid } = getState().auth;
		const finalUid =
			type === 'repo'
				? `${uid}/digitalRepository`
				: consultUid
				? consultUid
				: uid;
		const storageRef = getStorage(app, bucketRef);
		const path = `/${typeRef}/${finalUid}/${filename}`;
		const fileRef = newRef(storageRef, path);

		uploadBytes(fileRef, file)
			.then(() => {
				getDownloadURL(fileRef)
					.then((url) => {
						switch (type) {
							case 'repo':
								// C.V. or another personal documents
								if (filename)
									dispatch(
										updateConsultFileURL(url, filename)
									);
								else
									handleWarning(
										'Hace falta una nombre del archivo'
									);
								break;
							case 'fileConsult':
								// Consult files (PDFs and images)
								if (filename) {
									dispatch(
										updateConsultFileURL(url, filename)
									);
								} else
									handleWarning(
										'Hace falta una descripción y/o uid de orden'
									);
								break;
							default:
								console.log('Error in Type');
						}
					})
					.catch((error) => {
						handleError(error, 'Error en URL');
					});
			})
			.catch((error) => {
				handleSuccess(
					error,
					'Error subiendo archivos en uploadFile method'
				);
			});
	};
};
